var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWeb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#1B1F23"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.44023 11.6162C6.64565 9.05754 8.55513 6.97937 11.0328 6.51769C9.95491 8.00674 9.31427 9.77324 9.19128 11.6162H6.44023ZM17.7096 12.5336C17.5042 15.0922 15.5947 17.1704 13.1171 17.6321C14.1949 16.143 14.8356 14.3765 14.9586 12.5336H17.7096ZM9.19128 12.5336C9.31427 14.3765 9.95491 16.143 11.0328 17.6321C8.55513 17.1704 6.64564 15.0922 6.44023 12.5336H9.19128ZM14.9586 11.6162C14.8356 9.77324 14.1949 8.00674 13.1171 6.51769C15.5947 6.97937 17.5042 9.05754 17.7096 11.6162H14.9586ZM12.0749 5.50446C8.44617 5.50446 5.50449 8.44614 5.50449 12.0749V12.0749C5.50449 15.7036 8.44617 18.6453 12.0749 18.6453C15.7037 18.6453 18.6454 15.7036 18.6454 12.0749C18.6454 8.44614 15.7037 5.50446 12.0749 5.50446ZM14.0389 11.6162H10.1109C10.2444 9.80393 10.9302 8.076 12.0749 6.66575C13.2196 8.07601 13.9054 9.80393 14.0389 11.6162ZM12.0749 17.484C10.9302 16.0738 10.2444 14.3458 10.1109 12.5336H14.0389C13.9054 14.3458 13.2196 16.0738 12.0749 17.484Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/web.7862a7a110648c1eef4662515bc8b7cf.svg";
export { ForwardRef as ReactComponent };